export const PRODUCT_TYPE_ECARD = 'ecard';
export const PRODUCT_TYPE_PHYSICAL_CARD = 'physical_card';
export const PRODUCT_TYPE_PRODUCT = 'product';
export const PRODUCT_TYPE_LICENSE_AND_LICENSE_BUNDLE = 'license_and_license_bundle';
export const STOCK_TYPE_LICENSE = 'license';
